import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AuthService } from "../../../app/services/auth.service";
import { ButtonComponent } from "../button/button.component";
import { ModalSignupComponent } from "../modal-signup/modal-signup.component";

@Component({
  selector: "app-call-to-action-register",
  imports: [TranslateModule, ButtonComponent],
  templateUrl: "./call-to-action-register.component.html",
  styleUrl: "./call-to-action-register.component.scss",
})
export class CallToActionRegisterComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
  ) {}
  private authSubscription!: Subscription;
  isLoggedIn = false;

  ngOnInit(): void {
    this.authSubscription = this.authService.isLoggedIn.subscribe(
      (isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      },
    );
  }

  goToCreateEvent() {
    this.router.navigate(["/create-event"]);
  }

  openModalSignUp() {
    this.dialog.open(ModalSignupComponent, {
      width: "800px",
      maxWidth: "95vw",
    });
  }
}
